import {
    liveDetailAccessApi,
    liveDetailNoAccessApi,
    getCollectApi,
    getLiveAppointmentApi
} from '@/store/api/live';

const states = {
    isOverTime: null, // 是否过了预约时间
    liveDetail: null, // 直播详情信息
    collectId: null, // 收藏直播的id
    appointmentStatus: {}, // 直播预约状态信息
    mode: 'detail', // 直播模块当前模式(detail: 观看模式  lecturer: 讲师操作模式  preview: 预览模式)
};
const mutations = {
    setLiveDetail(mstate, res) {
        mstate.liveDetail = res;
    },
    updateRateScore(mstate, score) { // 更新直播评分数据
        mstate.liveDetail.avgScore = score;
    },
    setCollectID(mstate, id) {
        mstate.collectId = id;
    },
    setAppointment(mstate, res) {
        mstate.appointmentStatus = res;
    },
    setMode(mstate, res) {
        mstate.mode = res;
    },
    setOverTime(mstate, res) {
        mstate.isOverTime = res;
    }
};

const getters = {
};

const actions = {
    getLiveDetail({ commit }, payload) { // 根据id获取直播详情
        let index = 0;
        let { type } = payload;
        const { classID: businessId, code } = payload;
        if (!type && code === '12') { // 仅在后台专题预览直播情况出现，businessId缺失，type缺失，12为管理员权限
            type = code;
        }
        if (payload.mode === 'preview') index++;
        return [liveDetailAccessApi, liveDetailNoAccessApi][index](
            payload.id,
            index === 0 && Number(payload.code) === 99 ? {
                homeConfigId: payload.homeConfigId,
                businessId,
                type,
            } : {
                businessId,
                type,
            }
        ).then((res) => {
            commit('setLiveDetail', res.data);
            return res.data;
        });
    },
    getCollectInfo({ commit }, payload) { // 获取收藏信息
        const param = { businessId: payload.id };
        return getCollectApi(param).then((res) => {
            commit('setCollectID', res.data.id);
            return res.data;
        });
    },
    getLiveAppointmentStatus({ commit, state }) { // 获取直播预约状态
        return getLiveAppointmentApi(state.liveDetail.id).then((res) => {
            commit('setAppointment', res.data);
            return res.data;
        });
    }

};

export default {
    namespaced: true,
    getters,
    actions,
    mutations,
    state: states
};

